import { motion } from 'framer-motion';
import { Sparkles, Users, TrendingUp, Zap } from 'lucide-react';
import React from 'react';

const WelcomeScreen: React.FC = () => {
  return (
    <div className="text-center space-y-6">
      {/* Welcome Icon */}
      <motion.div
        className="flex justify-center"
        initial={{ scale: 0, rotate: -180 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      >
        <div className="w-20 h-20 bg-gradient-to-br from-cyan-500/20 to-purple-500/20 rounded-full flex items-center justify-center border-2 border-cyan-500/30">
          <Sparkles className="w-10 h-10 text-cyan-400" />
        </div>
      </motion.div>

      {/* Welcome Message */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <h2 className="text-3xl font-bold vscode-text-primary mb-4">
          Welcome to GoGrabJob!
        </h2>
        <p className="vscode-text-secondary text-lg leading-relaxed">
          Let's set up your profile to provide you with the best AI-powered resume optimization experience.
        </p>
      </motion.div>

      {/* Benefits */}
      <motion.div
        className="grid grid-cols-1 md:grid-cols-3 gap-3"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        <div className="vscode-bg-tertiary/50 rounded-lg p-3 border vscode-border">
          <Users className="w-8 h-8 text-cyan-400 mx-auto mb-2" />
          <h3 className="vscode-text-primary font-medium mb-1 text-sm">Personalized</h3>
          <p className="vscode-text-tertiary text-xs">Tailored to your industry and experience</p>
        </div>
        
        <div className="vscode-bg-tertiary/50 rounded-lg p-3 border vscode-border">
          <TrendingUp className="w-8 h-8 text-green-400 mx-auto mb-2" />
          <h3 className="vscode-text-primary font-medium mb-1 text-sm">Effective</h3>
          <p className="vscode-text-tertiary text-xs">95% success rate in improving match scores</p>
        </div>
        
        <div className="vscode-bg-tertiary/50 rounded-lg p-3 border vscode-border">
          <Zap className="w-8 h-8 text-purple-400 mx-auto mb-2" />
          <h3 className="vscode-text-primary font-medium mb-1 text-sm">Fast</h3>
          <p className="vscode-text-tertiary text-xs">Get optimized resumes in minutes</p>
        </div>
      </motion.div>

      {/* Setup Time */}
      <motion.div
        className="bg-cyan-500/10 border border-cyan-500/30 rounded-lg p-3"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.6 }}
      >
        <p className="text-cyan-400 text-xs">
          ⏱️ This setup takes less than 2 minutes and helps us provide better recommendations
        </p>
      </motion.div>
    </div>
  );
};

export default React.memo(WelcomeScreen);
